(function($) {
  
    $(document).ready(function() {
        
    });
  
})(jQuery);

function initCardPost(){
    var $ = jQuery;
    $(window).on('resize',function(){
        $('.m-card-post').each(function(){
            $(this).find('.image').css('height',$(this).find('.text').outerHeight());
        })
    }).trigger('resize')
}